import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { Alert } from '../../shared/alert/alert';
import { Card } from '../../shared/card/card';
import { getLastModifiedDate } from '../../../utils/date';
import { MeatballsMenu } from '../../shared/meatballs-menu/meatballs-menu';
import { CardType } from '../../../constants/payments';
import { getPaymentsErrorCode } from '../../../utils/payments';
import { ERR_UNABLE_TO_SAVE } from '../../../constants/response-error-messages';
import { DELETED_ACCOUNT_MSG, CHANGES_SAVED_MSG, DELETED_CARD_MSG, } from '../../../constants/response-success-messages';
import { pushErrorEvent } from '../../../utils/analytics';
import { usePayments } from '../../../hooks/use-payments';
import { useCustomerInfo } from '../../../hooks/use-customerInfo';
import { useMeatballMenuActions } from '../../../hooks/use-meatball-payment-actions';
import { CustomerRole } from '../../../models/common/customer';
export const CheckingAccountCard = ({ card, isMobile, index, setDeletedCreditCardIndex, onActionFailure, onActionSuccess, }) => {
    var _a, _b;
    const { alertMessage, setAlertMessage } = usePayments();
    const { role } = useCustomerInfo();
    const isAdmin = role === CustomerRole.ADMIN;
    const isCardAddedByPurchaser = card.level === 'user';
    const { checkingAccounts } = usePayments();
    const { onViewPurchases, onEditNickName, onDelete } = useMeatballMenuActions();
    const isHiddenForAdmin = isAdmin && isCardAddedByPurchaser;
    const handleEditNickName = () => {
        const currentCard = (checkingAccounts === null || checkingAccounts === void 0 ? void 0 : checkingAccounts.response).find((payment) => payment.paymentId === card.paymentId);
        const onSuccess = () => {
            onActionSuccess(card.paymentId, CHANGES_SAVED_MSG.message);
        };
        const onFailure = (error) => {
            const errorCode = getPaymentsErrorCode(error);
            onActionFailure(card.paymentId, ERR_UNABLE_TO_SAVE.message);
            pushErrorEvent('edit checking account', 'inline', errorCode || 'n/a', ERR_UNABLE_TO_SAVE.message);
        };
        onEditNickName(card, currentCard, CardType.CHECKING_ACCOUNT, onSuccess, onFailure);
    };
    const handleDeleteCard = () => {
        const onSuccess = () => {
            onActionSuccess(card.paymentId, DELETED_ACCOUNT_MSG.message);
        };
        const onFailure = (error) => {
            const errorCode = getPaymentsErrorCode(error);
            onActionFailure(card.paymentId, ERR_UNABLE_TO_SAVE.message);
            pushErrorEvent('checking accounts: delete', 'inline', errorCode || 'n/a', ERR_UNABLE_TO_SAVE.message);
        };
        onDelete(card, CardType.CHECKING_ACCOUNT, onSuccess, onFailure, () => {
            setDeletedCreditCardIndex(index);
        });
    };
    const menuItems = [
        {
            value: 'Add/Edit Nickname',
            action: handleEditNickName,
            isHidden: !((_a = card.actions) === null || _a === void 0 ? void 0 : _a.edit),
        },
        {
            value: 'View Purchases',
            action: () => {
                onViewPurchases(card, CardType.CHECKING_ACCOUNT);
            },
            isDisabled: !((_b = card.actions) === null || _b === void 0 ? void 0 : _b.viewPurchases),
        },
        {
            value: 'Delete',
            action: handleDeleteCard,
            isHidden: isHiddenForAdmin,
        },
    ];
    const isDeleteSuccessMessage = (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.text) === DELETED_CARD_MSG.message;
    const mobileCardAlertMessage = isMobile &&
        (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.paymentId) === card.paymentId &&
        !isDeleteSuccessMessage && (React.createElement("div", { className: "sui-mb-4" },
        React.createElement(Alert, { status: alertMessage.alertStatus, onClose: () => setAlertMessage(null) }, alertMessage.text)));
    return (React.createElement(React.Fragment, null,
        mobileCardAlertMessage,
        React.createElement(Card, { isDefault: false, isInactive: false, defaultLabel: "Default Payment Method" },
            React.createElement("div", { className: `sui-flex sui-justify-between sui-align-center ${card.cardNickName ? 'sui-mb-2' : 'sui-mb-3'}` },
                React.createElement("h3", { className: "sui-font-display sui-text-3xl sui-mr-4 sui-truncate sui-text-primary", "aria-label": "nickname" }, card.cardNickName),
                React.createElement("div", null,
                    React.createElement(MeatballsMenu, { label: "Payment", items: menuItems }))),
            React.createElement("div", { className: "sui-mb-6" },
                React.createElement(Typography, { variant: "body-lg", color: "subtle" },
                    "Account ****",
                    card.cardNumberLast4)),
            card.addedBy && (React.createElement("div", { className: "sui-overflow-hidden" },
                React.createElement(Typography, { truncate: true, color: "subtle" },
                    "Added by ",
                    React.createElement("span", { "data-qm-mask": "" }, card.addedBy)))),
            card.lastModifiedDate && (React.createElement(Typography, { color: "subtle" },
                "Last edited ",
                getLastModifiedDate(card.lastModifiedDate))))));
};
CheckingAccountCard.displayName = 'CheckingAccountCard';
